import React from "react";
import "./Testimonials.css";
import person1 from "../../assets/nimit.jpeg"; // replace with actual images
import person2 from "../../assets/abhinav.jpeg";

const Testimonials = () => {
  const data = [
    {
      name: "Abhinav Verma",
      image: person2,
      desc: "Smooth process from start to finish. Friendly staff and exactly what I needed without any hassle."
    },
    {
      name: "Nimit Singhal",
      image: person1,
      desc: "Fantastic service! Everything was done perfectly and on time. I really appreciate the extra care they put into every detail."
    }
  ];

  return (
    <section className="testimonials-wrapper">
      <div className="yellow-section">
        <h2>What do our users say?</h2>
      </div>

      <div className="cards-container">
        {data.map((item, index) => (
          <div className="testimonial-card" key={index}>
            <p>{item.desc}</p>
            <div className="profile">
              <img src={item.image} alt={item.name} />
              <h3>{item.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
